import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as _ from "lodash";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { DatePipe } from "@angular/common";
import { CustomAttributeFieldType, RmaStages, SOChannel, SOObjectNames, ShipmentStatus, TemplateType } from "src/app/inventory/sales-order/constants/constants";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { CustomerRMAModuleId } from "../../constants/modules.constant";
import { ProductsService } from "src/app/inventory/products/products.service";
import { environment } from "src/environments/environment";
import { AccountsTransactionType } from "src/app/finance/constants/constants";

@Component({
    selector: "app-return-details-view",
    templateUrl: "./return-details-view.component.html",
    styleUrls: ["./return-details-view.component.scss"],
})
export class ReturnDetailsViewComponent implements OnInit {
    @Input() type: any;
    @Input() trackingOptions :any = []
    @Input() customerReturnDetails: any;
    @Output() updateContextMenu = new EventEmitter<any>();
    utilityServiceObj: UtilityService;
    rmaStages: any[];
    fieldTypes = CustomAttributeFieldType;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    allRMATypes = [];
    allReasons = [];
    showApproveOption = false;
    selectedStage;
    selectedRMAType;
    selectedReason;
    // showShippingLabel: boolean = false;
    rmaProductList = [];
    isEdit = false;
    today = new Date();
    tempAttachment = [
        { id: 1, name: "panda.jpg", url:  `${environment.assestsBasePath}images/panda.jpg` },
        { id: 1, name: "test.doc", url: `${environment.assestsBasePath}images/panda.jpg` },
    ];
    approved = true;
    //tracking
    displayScanInfo = false;
    allChecked = false;
    nameLists = [];
    productSerialSettings:any;
    autoGenerateLists=[];
    totalTBRecord: number = 0;
    rowsPerPageTB = [100, 200, 300, 500];
    pageSize: number = 100;
    pageNumber: number = 1;
    first: number = 0;

    @ViewChild('stageAttachment')
    stageAttachment: any;
    customerInformation: any = {
        businessName: {
            value: "",
            show: true
        },
        customerAddress1: {
            value: "",
            show: false
        },
        customerAddress2: {
            value: "",
            show: false
        },
        customerName: {
            value: "",
            show: false
        },
        phoneNumber: {
            value: "",
            show: false
        },
    };
    shippingLocation: any = {
        businessName: {
            value: "",
            show: true
        },
        address1: {
            value: "",
            show: false
        },
        address2: {
            value: "",
            show: false
        },
        accountName: {
            value: "",
            show: false
        },
        phoneNumber: {
            value: "",
            show: false
        },
        addressName: {
            value: "",
            show: true
        },
    };
    rmaComments = [
        {
            userName: "User 1",
            date: new Date(),
            isApproved: true,
            stage: "Approved",
            comment: "This rma has been approved",
        },
        {
            userName: "User 2",
            date: new Date(),
            isApproved: false,
            stage: "Declined",
            comment: "This rma has been declined",
        },
    ];
    //tracking
    isPrefix: boolean = false;
    isAutoGenerated: boolean = false;
    displayImport = false;
    customerRmaObjectId;
    stageComment: string;
    rmaAttachments: any = [];
    MAX_SIZE: number = 5 * 1024 * 1024;
    totalFileSize: number = 0;
    attachmentList: any = [];
    attachmentId: any = 0;
    uploadedAttachments: any = [];
    rmaTemplate: any;
    customerRmaData: any = {
        rmaNumber: {
            value: "",
            show: true
        },
        invoiceNo: {
            value: "",
            show: true
        },
        status: {
            value: "",
            show: false
        },
        requestType: {
            value: "",
            show: false
        },
        createdDate: {
            value: "",
            show: false
        },
        location: {
            value: "",
            show: false
        },
        description: {
            value: "",
            show: false
        },
    };
    customerInformationLabel: string = 'Customer Information';
    shippingLocationLabel: string = 'Shipping Location';
    detailsLabel: string = 'Details';
    returnItemTable: any;
    requestTypeLabel: any;
    returnReasonLabel: any;
    footerColspan: any;
    subtotal: number = 0;
    totalRefund: number = 0;
    soChannel = SOChannel;
    allSections = [];
    rmaSections = [];
    allModules;
    orderObjId;
    allCustomAttributes;

    /** Shipment */
    displayShipmentDialog = false;
    isVisibleCarrier = true;
    shippingCarriers = [];
    selectedCarrier;
    shipMessage = "";
    displayFedexShipment = false;
    shipmentOptionAvailableFor = [RmaStages.Authorized, RmaStages.Received];
    isVisibleGenerateLabelOption = true;
    customerRmaId: number;
    glApiCall: boolean = false;
    transactionTypeIds = AccountsTransactionType;


    constructor(
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private salesOrderService: SalesOrderService,
        private datePipe: DatePipe,
        private utilityService: UtilityService,
        private productsService: ProductsService,
    ) { }

    ngOnInit(): void {
        this.utilityServiceObj = this.utilityService;
        this.customerRmaObjectId = this.app.preLoadedObjects.find(
            (obj) => obj.name == SOObjectNames.CustomerReturns
        )?.id;
        this.customerInformationLabel = 'Customer Information';
        this.shippingLocationLabel = 'Shipping Location';
        this.detailsLabel = 'Details';

        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
        this.productsService.getAllCustomFields(this.orderObjId).then((fields) => {
            this.allCustomAttributes = _.cloneDeep(fields);
            this.appMainService.isHideSpinner("loadCustomAttributes");
        });

        this.salesOrderService.getAllOrdersChannel("Order Section").subscribe((configs) => {
            this.allSections = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.rmaSections = this.allSections.filter((s) => s.typeId == CustomerRMAModuleId && s.isActive == true);
        });

        this.salesOrderService.getAllOrdersChannel("Orders Template").subscribe((configs) => {
            let allTemplates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.rmaTemplate = allTemplates?.filter((t) => t.typeId == TemplateType.CustomerRMA)[0];
            this.returnItemTable = this.rmaTemplate.labels_table;
            this.footerColspan = this.rmaTemplate.labels_table?.filter(x => x.isChecked)!.length + 1;
            this.requestTypeLabel = this.rmaTemplate.labels_section[0].labelname;
            this.returnReasonLabel = this.rmaTemplate.labels_section[4].labelname;
            this.customFields = this.utilityService.getCustomerRMACustomAttributes(this.rmaTemplate, this.allCustomAttributes);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.customerReturnDetails && changes.customerReturnDetails.currentValue) {
            this.customerRmaId = this.customerReturnDetails.id;
            this.customerReturnDetails = changes.customerReturnDetails.currentValue;
            this.prepareCustomerInformation();
            this.prepareShippingLocation();
            this.prepareRmaProductList();
            this.prepareRmaAttachments();
            this.prepareRmaData();
            this.rmaStages = this.customerReturnDetails.rmaStages;
            this.prepareApprovalStage();
            if (this.customerRmaObjectId) {
                this.getRmaComments();
            }
            if (this.customerReturnDetails) {
                this.checkIsVisibleGenerateLabelOption();
            }
        }
    }

    getSectionName(sectionCode) {
        const sectionName = this.rmaSections?.find(section => section.code == sectionCode)?.name;
        return sectionName;
    }

    prepareRmaData(): any {
        if (this.customerReturnDetails) {
            //rma and invoice number is shown by default
            this.customerRmaData.rmaNumber.value = this.customerReturnDetails.number;
            this.customerRmaData.invoiceNo.value = this.customerReturnDetails.invoiceNo;

            this.customerRmaData.createdDate.value = this.customerReturnDetails.createdDate;
            this.customerRmaData.createdDate.show = this.rmaTemplate.labels_misc[0].isChecked;
            this.customerRmaData.status.value = this.customerReturnDetails.status;
            this.customerRmaData.status.show = this.rmaTemplate.labels_misc[1].isChecked;
            this.customerRmaData.requestType.value = this.customerReturnDetails.requestType;
            this.customerRmaData.requestType.show = this.rmaTemplate.labels_misc[2].isChecked;
            this.customerRmaData.description.value = this.customerReturnDetails.description;
            this.customerRmaData.description.show = this.rmaTemplate.labels_misc[4].isChecked;
            this.customerRmaData.location.value = this.customerReturnDetails.location;
            this.customerRmaData.location.show = this.rmaTemplate.labels_misc[5].isChecked;
        }

        if (this.customerReturnDetails) {
            const controlTypeMappings = {
                "InputBox": (element, fc) => element.value = fc.value,
                "DatePicker": (element, fc) => element.value = this.datePipe.transform(fc.value, "MM/dd/yyyy"),
                "FileUpload": (element, fc) => element.customUploadedFiles = [...fc.customeAttachement],
                "Picture": (element, fc) => element.customUploadedFiles = [...fc.customeAttachement],
                "Rating": (element, fc) => element.value = fc.ratingId,
                "ToggleButton": (element, fc) => element.value = fc.toggle,
                "DropDownList": (element, fc) => element.value = fc.values,
                "RadioButton": (element, fc) => element.value = fc.values?.name,
                "CheckBox": (element, fc) => element.value = fc.multipleValues.map(el => el.name),
                "MultipleDropDownList": (element, fc) => element.value = [...fc.multipleValues],
            };

            // populate saved custom field data
            Object.keys(this.customFields).forEach((key) => {
                const dataArr = this.customFields[key];
                if (dataArr && dataArr.length > 0) {
                    dataArr.forEach((element) => {
                        const filteredCustom = this.customerReturnDetails.customAttributeValues.find(c =>
                            c.customAttributeId === element.id);
                        if (filteredCustom && element?.formControl?.name in controlTypeMappings) {
                            controlTypeMappings[element.formControl.name](element, filteredCustom);
                        }
                    });
                }
            });
        }
    }

    checkIsVisibleGenerateLabelOption(){
        this.isVisibleGenerateLabelOption = true;
        let isShipmentLabelCreated = false;
        if (this.customerReturnDetails?.rmaReturnShipment && this.customerReturnDetails?.rmaReturnShipment.length) {
            const shipments = this.customerReturnDetails?.rmaReturnShipment.filter((s) => s.statusId == ShipmentStatus.Active || s.statusId == ShipmentStatus.InActive);
            isShipmentLabelCreated = shipments && shipments.length > 0;
        }
        this.isVisibleGenerateLabelOption = !isShipmentLabelCreated && this.shipmentOptionAvailableFor.includes(this.customerReturnDetails.rmaStageId);
    }

    prepareRmaAttachments() {
        if (this.customerReturnDetails
            && this.customerReturnDetails.rmaAttachments) {
            this.rmaAttachments = this.customerReturnDetails.rmaAttachments;
        }
    }

    prepareApprovalStage() {
        if (
            this.customerReturnDetails.rmaStageId == 4 ||
            this.customerReturnDetails.rmaStageId == 5
        ) {
            this.rmaStages.forEach((x) => {
                if (x.id == this.customerReturnDetails.rmaStageId) {
                    x.isActive = true;
                }
            });
        } else {
            this.rmaStages.forEach((x) => {
                if (x.id == 6) {
                    x.isActive = true;
                }
            });
        }
    }

    prepareCustomerInformation() {
        if (this.customerReturnDetails) {
            let customerInfo = this.customerReturnDetails.customerInfo;

            if (customerInfo) {
                //business name shown by default
                this.customerInformation.businessName.value = customerInfo.businessName;

                this.customerInformation.customerName.value = customerInfo.accountName;
                this.customerInformation.customerName.show = this.rmaTemplate.labels_billaddress[0].isChecked;
                this.customerInformation.customerAddress1.value = customerInfo.address1;
                this.customerInformation.customerAddress1.show = this.rmaTemplate.labels_billaddress[1].isChecked;
                this.customerInformation.customerAddress2.value = customerInfo.address2;
                this.customerInformation.customerAddress2.show = this.rmaTemplate.labels_billaddress[2].isChecked;
                this.customerInformation.phoneNumber.value = customerInfo.phoneNumber;
                this.customerInformation.phoneNumber.show = this.rmaTemplate.labels_billaddress[4].isChecked;
            }
        }
    }

    prepareShippingLocation() {
        if (this.customerReturnDetails) {
            let address = this.customerReturnDetails.address;

            if (address) {
                //business name shown by default
                this.shippingLocation.businessName.value = address.businessName;
                this.shippingLocation.businessName.show = address.businessName;

                this.shippingLocation.accountName.value = address.accountName;
                this.shippingLocation.accountName.show = this.rmaTemplate.labels_shipaddress[0].isChecked;
                this.shippingLocation.address1.value = address.address1;
                this.shippingLocation.address1.show = this.rmaTemplate.labels_shipaddress[1].isChecked;
                this.shippingLocation.address2.value = address.address2;
                this.shippingLocation.address2.show = this.rmaTemplate.labels_shipaddress[2].isChecked;
                this.shippingLocation.phoneNumber.value = address.phoneNumber;
                this.shippingLocation.phoneNumber.show = this.rmaTemplate.labels_shipaddress[4].isChecked;
                this.shippingLocation.addressName.value = address.addressName;

            }
        }
    }

    prepareRmaProductList() {
        if (this.customerReturnDetails) {
            this.rmaProductList = this.customerReturnDetails.customerRMAProducts;
            for (let prd of this.rmaProductList) {
                prd.returnamt = prd.returnAmount;
                prd.returnqty = prd.returnQty;
                prd.bin = prd.bins?.filter(bin => bin.id == prd.binId).map(binData => binData.name)[0];
                for (let bItems of prd.rmaBundleDetails) {
                    bItems.returnamt = bItems.returnAmount;
                    bItems.returnqty = bItems.returnQty;
                    bItems.bin = bItems.bins?.filter(bin => bin.id == bItems.binId).map(binData => binData.name)[0];
                }
            }
            this.calculateSubTotalAmount();
            this.calculateTotalRefundAmount();

        }
    }

    calculateSubTotalAmount() {
        this.subtotal = 0;
        for (let prd of this.rmaProductList) {
            this.subtotal += this.roundToTwoDecimal(Number(prd.returnAmount))
        }
        this.subtotal = this.roundToTwoDecimal(this.subtotal);
    }

    roundToTwoDecimal(data: number) {
        return Math.round((data + Number.EPSILON) * 100) / 100;
    }

    calculateTotalRefundAmount() {
        this.totalRefund = 0;
        this.rmaProductList.forEach(
            (e) => (this.totalRefund += this.roundToTwoDecimal(Number(e.returnAmount)))
        );
        this.totalRefund = this.roundToTwoDecimal(this.totalRefund);
    }


    editRMA() {
        this.isEdit = true;
        this.salesOrderService.getAllReturnReasons().subscribe((res) => {
            if (res) {
                this.allReasons = res;
                this.selectedReason = this.allReasons?.find(reason => reason.id == this.customerReturnDetails?.rmaReasonId);
            }
        });
        this.salesOrderService.getAllReturnTypes().subscribe((res) => {
            if (res) {
                this.allRMATypes = res;
                this.selectedRMAType = this.allRMATypes?.find(type => type.id == this.customerReturnDetails?.rmaTypeId);
            }
        });
    }

    //tracking
    openScanInfo(product,type) {
        this.nameLists = [];
        this.autoGenerateLists = [];
        this.productSerialSettings = product.trackingSetting ? JSON.parse(product.trackingSetting) : null;
        this.displayScanInfo = true;
        const arr = [];
        if(type=='product'){
            if (product.rmaProductSerialDetails?.length > 0) {
                product.rmaProductSerialDetails.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: element.expirationDate,
                        systemPresent: true,
                    };
                    arr.push(obj);
                });
            }
        }else{
            if (product.rmaBundleProductSerialDetail?.length > 0) {
                product.rmaBundleProductSerialDetail.forEach((element) => {
                    const obj = {
                        id: element.id,
                        serialNo: element.barcode,
                        serialNo2: element.serialNumber2,
                        serialNo3: element.serialNumber3,
                        serialNo4: element.serialNumber4,
                        serialNo5: element.serialNumber5,
                        serialNo6: element.serialNumber6,
                        serialNo7: element.serialNumber7,
                        serialNo8: element.serialNumber8,
                        serialNo9: element.serialNumber9,
                        serialNo10: element.serialNumber10,
                        serialNo11: element.serialNumber11,
                        serialNo12: element.serialNumber12,
                        serialNo13: element.serialNumber13,
                        serialNo14: element.serialNumber14,
                        serialNo15: element.serialNumber15,
                        serialNo16: element.serialNumber16,
                        serialNo17: element.serialNumber17,
                        lotNo: element.lotNumber,
                        revisionNo: element.revisionNumber,
                        expiration: element.expirationDate,
                        systemPresent: true,
                    };
                    arr.push(obj);
                });
            }
        }
        this.autoGenerateLists = arr;
        this.nameLists = this.autoGenerateLists.slice(0, 100);
        this.totalTBRecord = this.autoGenerateLists.length;;
    }

    loadSerialsLazy(event) {
        if (this.autoGenerateLists) {
            this.nameLists = this.autoGenerateLists.slice(
                event.first,
                event.first + event.rows
            );
        }
    }

    getRmaComments() {
        this.salesOrderService
            .getRmaStageChangeHistory(
                this.customerReturnDetails.id,
                this.customerRmaObjectId
            )
            .subscribe((res) => {
                this.rmaComments = res;
            });
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }



}